import React, { Component } from 'react';
import {
  FormGroup, Label,
  Input,
  Row, Col,
  Card, CardBody
} from 'reactstrap';
import Validation from '../../services/Validation';
class NewFleetPrimaryContactDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      controls: {
        is_prospective: {
          value: false,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        primary_contact_person: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        primary_contact_designation: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        primary_mobile_number: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        primary_whatsapp_number: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        primary_email: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        same_as_owner: {
          value: false,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        }
      },
      isValidForm: false,
      fleetByIdData: {}
    }
  }

  changeFleetRegType = (e) => {
    const { NewFleetBusinessDetail } = this.props;
    let { controls } = this.state;

    if (NewFleetBusinessDetail.current &&
      NewFleetBusinessDetail.current.state.controls) {
      const { is_prospective } = NewFleetBusinessDetail.current.state.controls;
      if (is_prospective.value) {
        controls.is_prospective.value = is_prospective.value;
      } else {
        controls.is_prospective.value = false;
      }
    }
    this.setState({
      controls
    });
    this.handleValidation(false);
  }


  handleValidation = (isSubmit = false) => {
    let { controls, isValidForm } = this.state;
    let { primary_contact_person, primary_email, primary_whatsapp_number, primary_mobile_number, primary_contact_designation, is_prospective } = controls;
    if (primary_email.touched === true || isSubmit) {
      primary_email = Validation.notNullValidator(primary_email);
      primary_email = Validation.emailValidator(primary_email);
      primary_email.valid = !(primary_email.nullValue || primary_email.invalidEmail);
      if (primary_email.valid === false) {
        primary_email.showErrorMsg = true;
      } else {
        primary_email.showErrorMsg = false;
      }
    }

    if (primary_contact_person.touched === true || isSubmit) {
      primary_contact_person = Validation.notNullValidator(primary_contact_person);
      primary_contact_person.valid = !(primary_contact_person.nullValue);
      if (primary_contact_person.valid === false) {
        primary_contact_person.showErrorMsg = true;
      } else {
        primary_contact_person.showErrorMsg = false;
      }
    }

    if (primary_contact_designation.touched === true || isSubmit) {
      primary_contact_designation = Validation.notNullValidator(primary_contact_designation);
      primary_contact_designation.valid = !(primary_contact_designation.nullValue);
      if (primary_contact_designation.valid === false) {
        primary_contact_designation.showErrorMsg = true;
      } else {
        primary_contact_designation.showErrorMsg = false;
      }
    }


    if (primary_whatsapp_number.touched === true || isSubmit) {
      primary_whatsapp_number = Validation.notNullValidator(primary_whatsapp_number);
      primary_whatsapp_number = Validation.validatePhoneNumber(primary_whatsapp_number);
      primary_whatsapp_number = Validation.validateLength(primary_whatsapp_number, 10);
      primary_whatsapp_number.valid = !(primary_whatsapp_number.invalidPhone || primary_whatsapp_number.nullValue || primary_whatsapp_number.invalidLength);
      if (primary_whatsapp_number.valid === false) {
        primary_whatsapp_number.showErrorMsg = true;
      } else {
        primary_whatsapp_number.showErrorMsg = false;
      }
    }

    if (primary_mobile_number.touched === true || isSubmit) {
      primary_mobile_number = Validation.notNullValidator(primary_mobile_number);
      primary_mobile_number = Validation.validatePhoneNumber(primary_mobile_number);
      primary_mobile_number = Validation.validateLength(primary_mobile_number, 10);
      primary_mobile_number.valid = !(primary_mobile_number.invalidPhone || primary_mobile_number.nullValue || primary_mobile_number.invalidLength);
      if (primary_mobile_number.valid === false) {
        primary_mobile_number.showErrorMsg = true;
      } else {
        primary_mobile_number.showErrorMsg = false;
      }
    }

    if (is_prospective.value) {
      primary_email.showErrorMsg = false;
      primary_email.valid = true;
      primary_mobile_number.showErrorMsg = false;
      primary_mobile_number.valid = true;
      primary_whatsapp_number.showErrorMsg = false;
      primary_whatsapp_number.valid = true;
      primary_contact_person.showErrorMsg = false;
      primary_contact_person.valid = true;
      primary_contact_designation.showErrorMsg = false;
      primary_contact_designation.valid = true;
    }

    if (primary_email.valid === true && primary_mobile_number.valid === true &&
      primary_whatsapp_number.valid === true &&
      primary_contact_designation.valid === true &&
      primary_contact_person.valid === true) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }



    this.setState({ controls, isValidForm });
    return isValidForm;

  }

  setSameAsOwnerCheckBoxValue = (e) => {
    const { NewFleetBusinessDetail } = this.props;
    let { controls } = this.state;
    const controlName = e.target.name;
    controls[controlName].value = !controls[controlName].value;
    if (NewFleetBusinessDetail.current && NewFleetBusinessDetail.current.state.controls && controls[controlName].value) {
      const { owner_name, designation, mobile_number, whatsapp_number, email } = NewFleetBusinessDetail.current.state.controls;
      controls.primary_contact_person.value = owner_name.value;
      controls.primary_contact_designation.value = designation.value;
      controls.primary_mobile_number.value = mobile_number.value;
      controls.primary_whatsapp_number.value = whatsapp_number.value;
      controls.primary_email.value = email.value;
    }
    this.setState({
      controls
    });
    this.handleValidation(true);

  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    controls[controlName].touched = true;
    this.setState({ controls });
    this.handleValidation();
  }

  setFleetDetail = () => {
    let { fleetByIdData, controls } = this.state;
    fleetByIdData = this.props.fleetByIdData
    if (fleetByIdData && Object.keys(fleetByIdData).length > 0) {
      controls.primary_contact_person.value = fleetByIdData.primary_contact_person;
      controls.primary_email.value = fleetByIdData.primary_email;
      controls.primary_mobile_number.value = fleetByIdData.primary_mobile_number;
      controls.primary_whatsapp_number.value = fleetByIdData.primary_whatsapp_number;
      controls.primary_contact_designation.value = fleetByIdData.primary_contact_designation;
      this.setState({
        controls,
        fleetByIdData
      })
    }
  }

  setDesignation = (designation) => {
    // let { controls } = this.state;
    // controls.primary_contact_designation.value = designation;
    // this.setState({
    //   controls
    // })
  }
  render() {
    const { controls } = this.state;
    return (
      <>
        <Card>
          <CardBody>
            <Row>
              <Col xl="8" md="12" xs="12">
                <b className="margin-right-16">PRIMARY CONTACT DETAILS</b>
                <label className="custom-checkboax1--container">
                  <input type="checkbox" name="same_as_owner" checked={controls.same_as_owner.value}
                    onChange={(e) => this.setSameAsOwnerCheckBoxValue(e)}
                  />
                  <span className="checkmark1" />
                </label>&nbsp;&nbsp;<span className="text-capitalize">Same as owner</span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="primary_contact_person">Contact Person{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    name="primary_contact_person"
                    id="primary_contact_person"
                    value={controls.primary_contact_person.value}
                    onChange={(e) => this.handleInputChange(e)}
                    placeholder="Enter Conatct Person Name" />
                  {controls.primary_contact_person.showErrorMsg && <div className="error">*Please enter contact Person.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="primary_contact_designation">Designation{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Input
                    autocomplete="nofill"
                    type="text"
                    className="text-capitalize"
                    placeholder="Enter Designation"
                    name="primary_contact_designation"
                    onChange={(e) => this.handleInputChange(e)}
                    id="primary_contact_designation"
                    value={controls.primary_contact_designation.value}
                  />
                  {controls.primary_contact_designation.showErrorMsg && <div className="error">*Please select designation.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="primary_mobile_number">Mobile Number{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    name="primary_mobile_number"
                    id="primary_mobile_number"
                    onChange={(e) => this.handleInputChange(e)}
                    value={controls.primary_mobile_number.value}
                    placeholder="Enter 10 Digit Number" />
                  {controls.primary_mobile_number.showErrorMsg && <div className="error">*Please enter mobile number.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="primary_whatsapp_number">Whatsapp Number{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    name="primary_whatsapp_number"
                    id="primary_whatsapp_number"
                    onChange={(e) => this.handleInputChange(e)}
                    value={controls.primary_whatsapp_number.value}
                    placeholder="Enter 10 Digit Number" />
                  {controls.primary_whatsapp_number.showErrorMsg && <div className="error">*Please enter whatsapp number.</div>}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="primary_email">Email Address{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Input
                    autocomplete="nofill"
                    type="text"
                    name="primary_email"
                    onChange={(e) => this.handleInputChange(e)}
                    id="primary_email"
                    value={controls.primary_email.value}
                    placeholder="Enter Email Address" />
                  {controls.primary_email.showErrorMsg && <div className="error">*Please enter email address.</div>}
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </>
    );
  }
}

export default NewFleetPrimaryContactDetail;